import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import StatusButton from 'components/atoms/Button/StatusButton';
import CardCommentLists from 'components/molecules/Card/CardCommentLists';
import ChartInput from 'components/molecules/InputText/ChatInput';
import * as React from 'react';

const ExpandMore = styled(props => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(0deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const TitleSectionContent = styled(CardContent)(({ theme }) => ({
  padding: 'unset',
  paddingLeft: '16px',
}));

const HeadSectionContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  gap: '11px',
}));

const FooterSectionContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: 'unset',
  paddingTop: '20px',
  paddingLeft: '16px',
  paddingRight: '16px',
}));

const FooterSectionContent1 = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  gap: '15px',
  padding: 'unset',
}));

const HeadSectionSubBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  gap: '5px',
}));

const InsideImageContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  paddingTop: '20px',
}));

const InsideCommetContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
  paddingRight: '40px',
  paddingLeft: '40px',
  marginBottom: '20px',
  marginTop: '15px',
}));

const InsideBottomContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: '10px',
}));

const ToggleContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'end',
  alignItems: 'center',
  gap: '10px',
}));

const ContentText = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#ffffff',
  fontWeight: 'bold',
}));

const NameText = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#ffffff',
  fontWeight: 'bold',
}));

const TimeText = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  color: '#bcbcbc',
}));

const CommentTitleText = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#c1c1c1',
  fontWeight: 'bold',
}));

const GhostModeText = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  color: '#c1c1c1',
}));

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  alignSelf: 'self-end',
  color: '#c1c1c1',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    backgroundColor: '#3E3C4C',
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#c1c1c1',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 80%)',
    backgroundColor: '#3E3C4C',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,.35)'
        : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

const ProfileOtherPostCard = ({ isImg, isChart }) => {
  const avatar1 = require('assets/Profile/avatar1.png');

  const [expanded1] = React.useState(isImg);
  const [expanded2, setExpanded2] = React.useState(isChart);

  const [commetData, setCommetData] = React.useState([
    [
      '0',
      'Olxandr',
      'I love this!! I would love to get this NFT.',
      '123',
      '123',
      'small',
    ],
    [
      '0',
      'Maxim',
      'I love this!! I would love to get this NFT.',
      '15',
      '123',
      'small',
    ],
    [
      '1',
      'Who',
      'I love this!! I would love to get this NFT.',
      '47',
      '123',
      'small',
    ],
    [
      '1',
      'Am',
      'I love this!! I would love to get this NFT.',
      '47',
      '123',
      'small',
    ],
  ]);

  const handleExpand2Click = () => {
    setExpanded2(!expanded2);
  };

  const UserCommet = (deep, start, data) => {
    var newData = commetData.slice();
    setCommetData(newData);
  };
  return (
    <Card
      sx={{
        width: '100%',
        backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
        boxShadow: 'unset',
        borderRadius: '20px',
        marginTop: '16px',
      }}
    >
      <HeadSectionContent>
        <img src={avatar1} alt="avatar" />
        <HeadSectionSubBox>
          <NameText>@jamessmith49</NameText>
          <TimeText>2 minutes ago</TimeText>
        </HeadSectionSubBox>
      </HeadSectionContent>
      <TitleSectionContent>
        <ContentText>Looking forward to uploading my next work! 😃</ContentText>
      </TitleSectionContent>
      <Collapse in={expanded1} timeout="auto" unmountOnExit>
        <InsideImageContent>
          <video
            url="https://ktpublic-pics.s3.amazonaws.com/SampleVideo_720x480_2mb.mp4"
            autosize
            loop
          />
        </InsideImageContent>
      </Collapse>
      <FooterSectionContent>
        <FooterSectionContent1>
          <StatusButton type={'favor'} text={'20'} />
          <ExpandMore
            expand={expanded2}
            onClick={handleExpand2Click}
            aria-expanded={expanded2}
            aria-label="show more"
            sx={{ margin: 'unset' }}
          >
            <StatusButton type={'none'} text={'36'} />
          </ExpandMore>
          <StatusButton type={'money'} text={'6'} />
        </FooterSectionContent1>
        <Box
          sx={{
            color: '#ffffff',
            borderRadius: '20px',
            borderColor: '#ffffff',
            borderStyle: 'solid',
            fontSize: '8px',
            padding: '3px',
            paddingRight: '6px',
            paddingLeft: '6px',
            borderWidth: '1px',
          }}
        >
          $ TIP
        </Box>
      </FooterSectionContent>
      <Collapse in={expanded2} timeout="auto" unmountOnExit>
        <InsideCommetContent>
          <CommentTitleText onClick={handleExpand2Click}>
            Hide Comments
          </CommentTitleText>
          {commetData.slice(0, commetData.length).map((item, index) => {
            return (
              <CardCommentLists
                key={index}
                Index={index}
                isBig={item[0]}
                name={item[1]}
                comment={item[2]}
                answer={item[3]}
                favor={item[4]}
                imgSize={item[5]}
                commetAction={UserCommet}
              />
            );
          })}
          <InsideBottomContent>
            <img
              src={avatar1}
              style={{ width: '41px', height: '41px' }}
              alt={'img'}
            />
            <ChartInput
              CommetAc={function (deep, start, data) {
                throw new Error('Function not implemented.');
              }}
              hide={function () {
                throw new Error('Function not implemented.');
              }}
              deep={0}
              index={0}
            />
          </InsideBottomContent>
          <ToggleContent>
            <GhostModeText>Ghost mode</GhostModeText>
            <AntSwitch
              defaultChecked
              inputProps={{ 'aria-label': 'ant design' }}
            />
          </ToggleContent>
        </InsideCommetContent>
      </Collapse>
    </Card>
  );
};

export default ProfileOtherPostCard;
